import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  min-width: 15px;
  height: 15px;
  padding: 1px 2px 0px;
  border-radius: 10px;
  background: ${props => props.bgColor};
  color: ${props => props.color};
  display: ${props => (props.hidden && 'none') || 'flex'};
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 0.75rem;
`;

const Badge = ({ badgeContent, bgColor, color, max, showAlways }) => (
  <Wrapper
    bgColor={bgColor}
    color={color}
    hidden={!showAlways && badgeContent === 0}
  >
    {(badgeContent > max && `${max}+`) || badgeContent || ''}
  </Wrapper>
);
Badge.propTypes = {
  badgeContent: PropTypes.number,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  max: PropTypes.number,
  showAlways: PropTypes.bool,
};
Badge.defaultProps = {
  badgeContent: 0,
  bgColor: '#e24242',
  color: '#fff',
  max: 9,
  showAlways: false,
};
export default Badge;
